export const Navigator = {
  SceneConfig: {},
  SceneConfigs: {
    FadeAndroid: {},
  },
};

export default Navigator;
